// --- maps.js ---

var mapsCenters = []
var map
var latLonBounds
var googleMarkers = []
var infoWindow = null
var mapDefaults = {
  latitude: 59.963934,
  longitude: 10.781839,
  zoom: 17,
}
var manualPositioning = false

// Helper to add polygons from GeoJSON-ish [ [ [lng,lat], ...], [hole...], ... ]
function addPolygonsFromGeoJSON(polygons, options = {}) {
  if (!polygons || !polygons.length) return []

  const {
    // IMPORTANT: polygons will NOT affect bounds/zoom unless you set extendBounds: true
    extendBounds = false,
    strokeColor = '#00261d',
    strokeOpacity = 1,
    strokeWeight = 1,
    fillColor = '#00261d',
    fillOpacity = 1,
    clickable = false,
    zIndex = 0,
  } = options

  const created = []

  polygons.forEach((poly) => {
    const paths = poly.coordinates.map((ring) =>
      ring.map(([lng, lat]) => ({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      })),
    )

    const gPolygon = new google.maps.Polygon({
      paths,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      fillColor,
      fillOpacity,
      clickable,
      zIndex,
      map,
    })
    created.push(gPolygon)

    if (extendBounds) {
      // Only extends bounds if explicitly enabled
      const allPaths = gPolygon.getPaths()
      for (let i = 0; i < allPaths.getLength(); i++) {
        const path = allPaths.getAt(i)
        for (let j = 0; j < path.getLength(); j++) {
          latLonBounds.extend(path.getAt(j))
        }
      }
    }
  })

  return created
}

// Expose in case you ever want to call it manually
window.addPolygonsFromGeoJSON = addPolygonsFromGeoJSON

function createGoogleMap(mapSettings, markers = [], polygons = []) {
  if (!mapSettings.element.length) return

  var latitude = mapDefaults.latitude
  if (mapSettings.latitude) latitude = mapSettings.latitude

  var longitude = mapDefaults.longitude
  // FIX: correctly read longitude from mapSettings
  if (mapSettings.longitude) longitude = mapSettings.longitude

  var zoom = mapDefaults.zoom
  if (mapSettings.zoom) zoom = mapSettings.zoom

  var scrollwheel = false
  if (mapSettings.scrollwheel) scrollwheel = mapSettings.scrollwheel

  var styles = [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          weight: '2.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#9c9c9c',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#eeeeee',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7b7b7b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#3b5661',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c8d7d4',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#070707',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
  ]

  var mapLocation = new google.maps.LatLng(latitude, longitude)

  var mapOptions = {
    zoom: zoom, // keep the zoom you set
    center: mapLocation, // use your provided center
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    draggable: true,
    scrollwheel: scrollwheel,
    gestureHandling: 'cooperative',
    mapTypeControl: false,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_CENTER,
    },
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP,
    },
    scaleControl: false,
    streetViewControl: false,
    streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_TOP},
    fullscreenControl: false,
  }

  map = new google.maps.Map(mapSettings.element[0], mapOptions)

  if (mapSettings.maxZoom) map.setOptions({maxZoom: mapSettings.maxZoom})

  if (mapSettings.satellite) {
    map.setMapTypeId('satellite')
  } else {
    var styledMap = new google.maps.StyledMapType(styles, {name: 'Styled Map'})
    map.mapTypes.set('map_style', styledMap)
    map.setMapTypeId('map_style')
  }

  latLonBounds = new google.maps.LatLngBounds()

  infoWindow = new google.maps.InfoWindow({
    content: '...',
    maxWidth: 250,
  })

  // ------- markers -------
  googleMarkers = []
  if (markers && markers.length) {
    for (var markerIndex = 0; markerIndex < markers.length; markerIndex++) {
      var markerPosition = new google.maps.LatLng(
        markers[markerIndex].latitude,
        markers[markerIndex].longitude,
      )

      // We track bounds but we DO NOT auto-fit in this function
      latLonBounds.extend(markerPosition)

      var markerTitle = mapDefaults.title
      if (markers[markerIndex].title) markerTitle = markers[markerIndex].title

      var markerImage = new google.maps.MarkerImage(
        mapDefaults.marker,
        new google.maps.Size(29, 42),
        new google.maps.Point(0, 0),
        new google.maps.Point(15, 42),
      )

      if (markers[markerIndex].markerImage) {
        var markerScale = markers[markerIndex].markerScale || 1
        var markerWidth = parseInt(markers[markerIndex].markerSize.width)
        var markerHeight = parseInt(markers[markerIndex].markerSize.height)
        var markerScaledWidth = markerWidth * markerScale
        var markerScaledHeight = markerHeight * markerScale

        markerImage = {
          url: markers[markerIndex].markerImage,
          scaledSize: new google.maps.Size(markerScaledWidth, markerScaledHeight),
        }
        if (markers[markerIndex].markerAnchor) {
          markerImage.anchor = new google.maps.Point(
            parseInt(markers[markerIndex].markerAnchor.x) * markerScale,
            parseInt(markers[markerIndex].markerAnchor.y) * markerScale,
          )
        }
      }

      var infowWindowContent
      if (mapSettings.infoWindows) {
        // … build your content here if needed …
      }

      var label = null
      if (mapSettings.clusterer) {
        label = {
          text: '1',
          fontSize: '16px',
          color: 'white',
        }
      }

      var marker = new google.maps.Marker({
        title: markerTitle,
        position: markerPosition,
        zIndex: 1,
        html: infowWindowContent,
        map: map,
        id: markers[markerIndex].id,
        icon: markerImage,
        label: label,
      })

      infoWindow.setOptions({maxWidth: 600})

      if (infowWindowContent) {
        google.maps.event.addListener(marker, 'click', function () {
          infoWindow.setContent(this.html)
          infoWindow.open(map, this)
        })
      }

      if (mapSettings.infoOverlay) {
        google.maps.event.addListener(marker, 'click', function () {
          resetMapOverlays()
          jQuery('#overlay-' + this.id).removeClass('hidden')

          // Re-center only; do NOT change zoom
          map.setCenter(this.position)
          manualPositioning = true

          googleMarkers.forEach(function (m) {
            var label = m.getLabel && m.getLabel()
            if (label) {
              label.color = 'white'
              m.setLabel(label)
            }
            if (mapSettings.defaultMarkerImage) {
              var defaultMarkerImage = {
                url: mapSettings.defaultMarkerImage,
                scaledSize: new google.maps.Size(markerScaledWidth, markerScaledHeight),
              }
              m.setIcon(defaultMarkerImage)
            }
          })

          var label = this.label
          if (label) {
            this.label.color = '#00261d'
            this.setLabel(label)
          }

          if (mapSettings.activeMarkerImage) {
            var activeMarkerImage = {
              url: mapSettings.activeMarkerImage,
              scaledSize: new google.maps.Size(markerScaledWidth, markerScaledHeight),
            }
            this.setIcon(activeMarkerImage)
          }
        })
      }

      googleMarkers.push(marker)
    }
  }

  // ------- clusterer (safe default icon) -------
  if (mapSettings.clusterer) {
    new markerClusterer.MarkerClusterer({
      map: map,
      markers: googleMarkers,
      renderer: {
        render: function (o) {
          var markersArr = o.markers
          var position = o._position
          return new google.maps.Marker({
            position: {
              lat: position.lat(),
              lng: position.lng(),
            },
            zIndex: 1,
            map: map,
            // No custom icon by default; add mapSettings.clusterIcon if you want
            icon: mapSettings.clusterIcon || null,
            label: {
              text: markersArr.length > 10 ? '10+' : '' + markersArr.length,
              fontSize: '16px',
              color: 'white',
            },
          })
        },
      },
    })
  }

  // ------- polygons -------
  // Accept either: (a) array of polygons OR (b) object { items: [], options: { ... } }
  var polygonItems = Array.isArray(polygons)
    ? polygons
    : polygons && Array.isArray(polygons.items)
      ? polygons.items
      : []

  var polygonOptions = polygons && polygons.options ? polygons.options : {}

  // Draw polygons; by default they DO NOT change bounds/zoom
  addPolygonsFromGeoJSON(polygonItems, {
    ...polygonOptions,
    extendBounds: !!mapSettings.fitToPolygons, // default false
  })

  // Centering rules (no auto-zoom changes):
  // - If exactly 1 marker: center on it (keep current zoom)
  // - Else: keep the initial center from mapSettings
  if (markers.length === 1) {
    map.setCenter(new google.maps.LatLng(markers[0].latitude, markers[0].longitude))
  } else {
    map.setCenter(mapLocation)
  }

  // Keep the center (and current zoom) on resize; no auto-fit
  google.maps.event.addDomListener(window, 'resize', function () {
    if (manualPositioning) return
    if (markers.length === 1) {
      map.setCenter(new google.maps.LatLng(markers[0].latitude, markers[0].longitude))
    } else {
      map.setCenter(mapLocation)
    }
  })

  jQuery('.map').on('click', function () {
    if (!manualPositioning) resetMapOverlays()
    manualPositioning = false
  })
}

function resetMapOverlays() {
  jQuery('.map-overlay').addClass('hidden')
}

function showStreetview(element, streetviewSettings) {
  var povPitch = streetviewSettings.pitch || 50
  var povHeading = streetviewSettings.heading || 120
  var panoramaOptions = {
    position: new google.maps.LatLng(streetviewSettings.latitude, streetviewSettings.longitude),
    draggable: false,
    scrollwheel: false,
    pov: {
      heading: povHeading,
      pitch: povPitch,
    },
  }
  var panorama = new google.maps.StreetViewPanorama(element[0], panoramaOptions)
}

export function updateGoogleMapMarkers(ids) {
  for (var i = 0; i < googleMarkers.length; i++) {
    if (ids === 'all' || ids.indexOf(googleMarkers[i].id) > -1) {
      googleMarkers[i].setVisible(true)
    } else {
      googleMarkers[i].setVisible(false)
    }
  }
  // We keep this utility: it will fit to *visible markers* (changes zoom)
  // Call it manually only if you want that behavior.
  fitGoogleMapMarkers()
}

export function fitGoogleMapMarkers() {
  latLonBounds = new google.maps.LatLngBounds()
  var visibleMarkerCounter = 0
  for (var i = 0; i < googleMarkers.length; i++) {
    if (googleMarkers[i].visible) {
      visibleMarkerCounter++
      latLonBounds.extend(googleMarkers[i].position)
    }
  }
  if (visibleMarkerCounter >= 1) map.fitBounds(latLonBounds)
}

window.createGoogleMap = createGoogleMap
